document.addEventListener('click', function (e) {
  const swatchLink = e.target.closest(
    'product-info[data-view-mode="quick-view"] .product-form__input--color a[href]'
  );
  if (!swatchLink) return;
  if (swatchLink.classList.contains('current')) return;

  e.preventDefault();

  const productInfo = swatchLink.closest('product-info[data-view-mode="quick-view"]');
  const sectionId   = productInfo.dataset.section;
  const productPath = new URL(swatchLink.href).pathname;

  productInfo.style.opacity       = '0.5';
  productInfo.style.pointerEvents = 'none';

  fetch(`${productPath}?sections=${encodeURIComponent(sectionId)}`)
    .then(r => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return r.json();
    })
    .then(data => {
      const html = data[sectionId];
      if (!html) throw new Error('Section introuvable dans la réponse');

      const doc           = new DOMParser().parseFromString(html, 'text/html');
      const newSection    = doc.querySelector('.product') || doc.body;
      const newProductInfo = doc.querySelector('product-info'); // ← nouveau

      productInfo.innerHTML = newSection.innerHTML;

      // ── Sync attributs product-info ──────────────────────────────
      if (newProductInfo) {
        productInfo.dataset.productId = newProductInfo.dataset.productId;
        productInfo.dataset.url       = newProductInfo.dataset.url;
      }
      // ─────────────────────────────────────────────────────────────

      productInfo.dispatchEvent(
        new CustomEvent('quickview:reloaded', { bubbles: true })
      );

      // ── Fix variant-selects ──────────────────────────────────────
      requestAnimationFrame(() => {
        const vs = productInfo.querySelector('variant-selects');
        if (!vs) return;

        const parent = vs.parentNode;
        const anchor = vs.nextSibling;
        vs.remove();

        requestAnimationFrame(() => {
          anchor ? parent.insertBefore(vs, anchor) : parent.appendChild(vs);

          setTimeout(() => {
            const checked = vs.querySelector('input[type="radio"]:checked');
            if (checked) checked.dispatchEvent(new Event('change', { bubbles: true }));
          }, 50);
        });
      });
      // ─────────────────────────────────────────────────────────────
    })
    .catch(err => {
      console.error('[faux-variant quickview]', err);
    })
    .finally(() => {
      productInfo.style.opacity       = '';
      productInfo.style.pointerEvents = '';
    });
});